import experimentSingleton from '../vendor/experiment.vendor'

export const SALES_FEATURE_FLAGS = {
  SalesNewLayoutEnabled: 'sales_new_layout_enabled'
}

async function isSalesNewLayoutFlagEnabled () {
  return await experimentSingleton.isFlagActive(
    SALES_FEATURE_FLAGS.SalesNewLayoutEnabled
  )
}

export { isSalesNewLayoutFlagEnabled }
